module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./PieChart.js"));
	}, "PieChart");
}